import React from 'react';
import * as S from './qr-code.styles';

const QRCode = ({ value, ...rest }) => {
  return <S.CustomQRCode renderAs={'svg'} value={value} {...rest} />;
};

export default QRCode;
